import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, FieldArray, reduxForm, propTypes as formPropTypes } from 'redux-form';
import SessionDateTime from '../../forms/ReduxFormDateTimeArrayInput';
import ReduxFormInput from '../../forms/ReduxFormInput';
import Icon from '../../icons/Icon';
import numeral from 'numeral';

const REQUEST_MAX_DAYS_FROM_NOW = 74;

const validate = values => {
  const errors = {};
  const { requestedDates, note } = values;
  const sectionsErrors = [];

  requestedDates.forEach((section, i) => {
    const sectionErrors = {};

    if (!section.date) {
      sectionErrors.date = 'Date is required';
    }

    if (!section.time) {
      sectionErrors.time = 'Time is required';
    }

    sectionsErrors[i] = sectionErrors;
  });

  if (sectionsErrors.length) {
    errors.requestedDates = sectionsErrors;
  }

  if (!note || !note.trim()) {
    errors.note = 'Please include a note';
  } else if (note.length > 255) {
    errors.note = 'Note must be less than 256 characters';
  }

  return errors;
};

class SessionRequestChapterAndDateForm extends Component {
  static propTypes = {
    ...formPropTypes,
    availability: PropTypes.string.isRequired,
    headerText: PropTypes.string.isRequired,
    imageLocation: PropTypes.string,
    isMobile: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    timeZoneId: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['in-person', 'movement-specialist', 'online']).isRequired,
    customIcon: PropTypes.string,
    price: PropTypes.number,
  };

  render() {
    const {
      availability,
      headerText,
      imageLocation,
      handleSubmit,
      onCancel,
      submitting,
      isMobile,
      timeZoneId,
      type,
      customIcon,
    } = this.props;

    const price = numeral(this.props.price / 100).format('$0,0')

    let hourSelect = (
      <div>
      <div className="dropdown"></div>
      <select>
        <option value="1">1 Hour</option>
        <option value="2">2 Hours</option>
        <option value="3">3 Hours</option>
        <option value="4">4 Hours</option>
      </select>
      </div>
    )

    if (!this.props.price > 0) {
      hourSelect = (
        <select>
          <option value="1">1 Hour</option>
        </select>
      )
    }

    return (
      <div>
        <div className="ms__request">
          {imageLocation ? (
            <div style={{ backgroundImage: `url(${imageLocation})` }} className="ms__request-img" />
          ) : (
              <Icon icon={customIcon ? customIcon : 'Person'} />
            )}
          <h4>{headerText}</h4>
          <span>Availability: {availability}</span>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="ms__request-form">
            <Field
              name="note"
              component={ReduxFormInput}
              label="Add a note about what you want to discuss during your follow-up"
            >
              <textarea />
            </Field>
            <span className="ms__request-form-title">For how many hours? ({price} per hour)</span>
            <Field name="hours" component={ReduxFormInput}>
              {hourSelect}
            </Field>
            <span className="ms__request-form-title">Please select a few dates and times that work for you</span>
            <FieldArray
              allowDays={REQUEST_MAX_DAYS_FROM_NOW}
              component={SessionDateTime}
              isMobile={isMobile}
              minSize="1"
              maxSize="3"
              name="requestedDates"
              timezone={timeZoneId}
              type={type}
            />
          </div>
          <div className="modal__actions">
            <button type="button" className="button button--theme--plain" onClick={onCancel} disabled={submitting}>
              Cancel
            </button>
            <button type="submit" className="button" disabled={submitting}>
              Next
            </button>
          </div>
        </form>
      </div>
    );
  }
}

export default reduxForm({
  form: 'sessionRequestForm',
  onSubmitFail: () => {
    window.scrollTo(0, 0);
  },
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
})(SessionRequestChapterAndDateForm);



// WEBPACK FOOTER //
// ./src/common/components/session-requests/SessionRequestChapterAndDateForm.js